/**
 * Formular „Mitreden“ (EXT:form, H):
 *  - Mit JS prüft der Server (novalidate): eine leere Eingabe führt zur Fehlerzusammenfassung
 *    statt zu den Browser-Blasen. Ohne JS bleibt die Browser-Prüfung (required) aktiv.
 *  - Nach einem fehlgeschlagenen Absenden bekommt die Zusammenfassung (.c-form__summary) den Fokus,
 *    ihre Links setzen den Fokus ins jeweilige Feld.
 *  - Auf der Danke-Seite bekommt die Bestätigung ([data-form-done]) den Fokus.
 * Der Fokus wird erst nach "load" gesetzt: der Sprung zum #anker der Formular-Action
 * nimmt einen früher gesetzten Fokus wieder weg (Chromium).
 */
export function initForm() {
  document.querySelectorAll('.frame-type-form_formframework form').forEach((form) => {
    form.noValidate = true;
  });

  const summary = document.querySelector('.c-form__summary');
  if (summary) {
    summary.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      const field = link && document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!field) return;
      e.preventDefault();
      const label = document.querySelector(`label[for="${CSS.escape(field.id)}"]`);
      (label || field).scrollIntoView({ block: 'center' });
      field.focus({ preventScroll: true });
    });
  }
  const target = summary || document.querySelector('[data-form-done]');
  if (!target) return;
  const focus = () => requestAnimationFrame(() => target.focus());
  if (document.readyState === 'complete') focus();
  else window.addEventListener('load', focus, { once: true });
}
